import { NAV_CONTENT } from './nav-content';
import { FOOTER_CONTENT } from './footer-content';
import ServiceConstants from './service';

export default angular.module('webPublicClient.app.shared.constants', [
])
.constant('NAV_CONTENT', NAV_CONTENT)
.constant('FOOTER_CONTENT', FOOTER_CONTENT)
.constant('SERVICE', new ServiceConstants('/dsw/webPublicClient/secure/jas'));



// WEBPACK FOOTER //
// ./src/app/shared/constants/index.js